import { FC } from "react";
import styled from "styled-components";

import { ChannelFinancesResource } from "@/types/resources";
import { Td } from "@/components/Table";
import NetworkIcon from "@/components/NetworkIcon";
import Text from "@/components/Text";
import { numFormatter } from "@/utils/helpers";

export const Description = styled.div`
  display: flex;
  align-items: center;
  svg {
    position: absolute;
    top: -2px;
    left: -2px;
  }
`;

export const DescriptionText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 20px;
`;

export const ImageWrap = styled.div`
  position: relative;
`;

export const Image = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
  flex-shrink: 0;
  border: 1px solid rgba(144, 144, 144, 0.3);
`;

export const Tr = styled.tr`
  ${Td} {
    padding: 28px 20px;
  }
`;

interface Props {
  channel: ChannelFinancesResource;
}

const AllChannelsTableRow: FC<Props> = ({ channel }) => {
  const { total_views } = channel;

  return (
    <Tr>
      <Td>
        <Description>
          {!!channel.thumbnail && (
            <ImageWrap>
              <Image
                src={channel.thumbnail}
                alt={channel.name + " thumbnail"}
                loading="lazy"
              />
              <NetworkIcon type={channel.network} />
            </ImageWrap>
          )}

          <DescriptionText>
            <Text $type="smallBold">{channel.name}</Text>
            <Text
              $type="extraSmall"
              $color="gray"
              as="a"
              href={channel.url}
              target="_blank"
            >
              {channel.url}
            </Text>
          </DescriptionText>
        </Description>
      </Td>
      <Td>{total_views ? numFormatter(total_views) : "-"}</Td>
    </Tr>
  );
};

export default AllChannelsTableRow;
